import styled from '@emotion/styled';
import breakpoints from '../Theme/breakpoints';

const MainAdUnitContainer = styled.div`
  && {
    display: none;

    @media (min-width: ${breakpoints.lg}px) {
      display: block;
      border-top: 1px solid var(--grey-dark);
      padding: 24px 0;
    }
  }
`;

export default MainAdUnitContainer;
